import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './CompanyProfileModal.css'
import config from '../../config'
import {
  Link,
  LinkIcon
} from '../'
import Modal from 'react-modal'
import { includes } from 'lodash'

const CompanySectors = require('../../data/CompanySectors.json')
const CompanyLinks = require('../../data/CompanyLinks.json')
const CompanyProfiles = require('../../data/CompanyProfiles.json')

@CSSModules(Styles, {allowMultiple: true})
export default class CompanyProfileModal extends Component {
  static propTypes = {
    company_id: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props);
    this.state = {
      modalOpen: false
    }
  }
  openModal = () =>{
    this.setState({ modalOpen: true })
  }
  closeModal = () =>{
    this.setState({ modalOpen: false })
  }
  renderFlags = (flags) => {
    if (flags.length > 0) {
      return (
        <div styleName='flag-box'>
          { flags.map((flag)=>{
            const splitName = flag[2].split(' ')
            let shortname = splitName[0]
            shortname = (shortname === 'Palm') ? 'Palm oil' : shortname
            const type = splitName[splitName.length - 1]

            return (
              <span 
                styleName={
                  'flag ' +
                  (
                    type === 'producer' ? 'flag-p' : 'flag-c'
                  )
                }
                key={flag[0]}
              >
                <img
                  styleName='detail-icon-holding'
                  src={flag[1]}
                  alt={flag[2]}
                  title={flag[2]}
                />
                {shortname}
              </span>
            ) } ) }
        </div>
      )
    } else {
      return null
    }
  }
  render() {
    const entry = CompanyProfiles.data[this.props.company_id]

    if (!entry) {
      return (
        <span>{this.props.children}</span>
      )
    }

    const shortName = entry[0]
    const profile = entry[1]

    const producersIcon = require( '../../../static/images/icn-producers.svg' )
    // const financiersIcon = require( '../../../static/images/icn-banks.svg' )
    const consumersIcon = require( '../../../static/images/icn-consumers.svg' )
    const iconPo = require( '../../../static/images/icn-po.svg' )
    const iconPp = require( '../../../static/images/icn-pp.svg' )
    const iconRb = require( '../../../static/images/icn-rb.svg' )
    const iconTb = require( '../../../static/images/icn-tb.svg' )
    const iconBf = require( '../../../static/images/icn-bf.svg' )
    const iconSy = require( '../../../static/images/icn-sy.svg' )
    const iconPoY = require( '../../../static/images/icn-po-y.svg' )
    const iconPpY = require( '../../../static/images/icn-pp-y.svg' )
    const iconRbY = require( '../../../static/images/icn-rb-y.svg' )
    const iconTbY = require( '../../../static/images/icn-tb-y.svg' )
    const iconBfY = require( '../../../static/images/icn-bf-y.svg' )
    const iconSyY = require( '../../../static/images/icn-sy-y.svg' )

    const pflags = []
    const cflags = []
    const c = CompanySectors.data[this.props.company_id]
    if (includes(c, 'is_po_p')){ pflags.push(['is_po_p', iconPo, 'Palm oil producer']) }
    if (includes(c, 'is_pp_p')){ pflags.push(['is_pp_p', iconPp, 'Paper/pulp producer']) }
    if (includes(c, 'is_rb_p')){ pflags.push(['is_rb_p', iconRb, 'Rubber producer']) }
    if (includes(c, 'is_tb_p')){ pflags.push(['is_tb_p', iconTb, 'Timber producer']) }
    if (includes(c, 'is_bf_p')){ pflags.push(['is_bf_p', iconBf, 'Cattle producer']) }
    if (includes(c, 'is_sy_p')){ pflags.push(['is_sy_p', iconSy, 'Soy producer']) }

    if (includes(c, 'is_po_c')){ cflags.push(['is_po_c', iconPoY, 'Palm oil major consumer brand']) }
    if (includes(c, 'is_pp_c')){ cflags.push(['is_pp_c', iconPpY, 'Paper/pulp major consumer brand']) }
    if (includes(c, 'is_rb_c')){ cflags.push(['is_rb_c', iconRbY, 'Rubber major consumer brand']) }
    if (includes(c, 'is_tb_c')){ cflags.push(['is_tb_c', iconTbY, 'Timber major consumer brand']) }
    if (includes(c, 'is_bf_c')){ cflags.push(['is_bf_c', iconBfY, 'Cattle major consumer brand']) }
    if (includes(c, 'is_sy_c')){ cflags.push(['is_sy_c', iconSyY, 'Soy major consumer brand']) }

    const is_p = pflags.length > 0
    const is_c = cflags.length > 0

    const links = CompanyLinks.data[this.props.company_id]
    const zsl_spott = links ? links.zsl_spott : ''
    const supply_change = links ? links.supply_change : ''
    const banktrack = links ? links.banktrack : ''
    const rspo = links ? links.rspo : ''
    const forest500 = links ? links.forest500 : ''
    const other_link = links ? links.other_link : ''
    const link_map = [[zsl_spott, 'ZSL SPOTT'],
                      [supply_change, 'Supply Change'],
                      [banktrack, 'BankTrack'],
                      [rspo, 'RSPO'],
                      [forest500, 'Forest500'],
                      [other_link, 'Other']]

    const has_links = (zsl_spott || supply_change || banktrack || rspo ||
                       forest500 || other_link)

    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/companies/'+this.props.company_id+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }

    //
    return (
      <span>
        <span onClick={this.openModal} styleName='modal-opener'>
          {this.props.children}<LinkIcon faclass='fa-info-circle'/>
        </span>

        <Modal
          isOpen={this.state.modalOpen}
          onRequestClose={this.closeModal}
          contentLabel="This fund is managed by"
          style={{
            overlay : {
              backgroundColor   : 'rgba(0, 0, 0, 0.75)'
            },
            content: {
              position                   : 'absolute',
              left                       : 0,
              right                      : 0,
              marginLeft                 : 'auto',
              marginRight                : 'auto',
              borderRadius               : 0,
              width                      : '900px',
              maxWidth                   : '90%',
              top                        : '50%',
              border                     : '0px',
              background                 : '#fff',
              overflow                   : 'visible',
              bottom                     : 'auto',
              WebkitOverflowScrolling    : 'touch',
              outline                    : 'none',
              transform                  : 'translateY(-50%)',
              padding                    : 0
            }
          }}>
          <div styleName='family-modal-wrap'>
            <div styleName='family-modal'>
              <div styleName='family-modal-header-wrap'>
                <div styleName='family-modal-header'>{shortName}</div>

                {
                  hasLogo ?
                    (
                      <img
                        styleName='company-logo-img'
                        src={companyLogo}
                        alt={shortName}
                      />
                    ) :
                    null
                }

              </div>
              <div styleName='family-modal-p'>{profile}</div>

              <div styleName='modal-icons-wrap'>
                { is_p ? (
                    <div styleName='icons-wrap'>
                      <div styleName='sector-headline-wrap'>
                        <img
                          styleName='sector-icon'
                          src={producersIcon}
                          alt='Deforestation-risk agricultural commodity producer/trader'
                        />
                        <div styleName='sector-headline-p'>
                          Agricultural commodity producer/trader
                        </div>
                      </div>
                      { this.renderFlags(pflags) }
                    </div>
                  ) : null }
                { is_c ? (
                    <div styleName='icons-wrap'>
                      <div styleName='sector-headline-wrap'>
                        <img
                          styleName='sector-icon'
                          src={consumersIcon}
                          alt='Major consumer brands'
                        />
                        <div styleName='sector-headline-c'>
                          Major consumer brand
                        </div>
                      </div>
                      { this.renderFlags(cflags) }
                    </div>
                  ) : null }
              </div>
              { /* if the company has any research links...  */
                has_links ? (
                  <div styleName='links-box'>
                    <div styleName='links-headline'>
                      Source information:
                    </div>
                    { /* ..display links for the company  */
                      link_map.map((e, i) => {
                        const has_link = e[0].length
                        if (has_link) {
                          return (
                            <div key={i} styleName='research-link-div'>
                              <Link
                                to={e[0]}
                                title={e[1]}
                                xstrong={true}
                              >
                                {e[1]}<LinkIcon />
                              </Link>
                            </div>
                          )
                        } else {
                          return null
                        }
                      })
                    }
                  </div>
                ) : null
              }
            </div>
            <div styleName='family-modal-close-wrap' onClick={ this.closeModal }>
              <div styleName='family-modal-close' className='fa fa-times'></div>
            </div>
          </div>
        </Modal>
      </span>
    )
  }
}

